// Generated by purs version 0.15.16
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Lazy from "../Control.Lazy/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Gen from "../Control.Monad.Gen/index.js";
import * as Control_Monad_Gen_Class from "../Control.Monad.Gen.Class/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_Gen from "../Data.String.Gen/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Expr from "../Expr/index.js";
import * as Halogen_Component from "../Halogen.Component/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Events from "../Halogen.HTML.Events/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_Query_HalogenM from "../Halogen.Query.HalogenM/index.js";
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var environmentIsSymbol = {
    reflectSymbol: function () {
        return "environment";
    }
};
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons(environmentIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "target";
    }
})(Expr.showExpr));
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(nameIsSymbol);
var valueIsSymbol = {
    reflectSymbol: function () {
        return "value";
    }
};
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(valueIsSymbol);
var MkClosureIsSymbol = {
    reflectSymbol: function () {
        return "MkClosure";
    }
};
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var eqRec = /* #__PURE__ */ Data_Eq.eqRec();
var eqRowCons = /* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)();
var eqRowCons1 = /* #__PURE__ */ eqRowCons(valueIsSymbol);
var eq = /* #__PURE__ */ Data_Eq.eq(Expr.eqExpr);
var max = /* #__PURE__ */ Data_Ord.max(Data_Ord.ordInt);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM);
var put = /* #__PURE__ */ Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM);
var pure = /* #__PURE__ */ Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM);
var modify_ = /* #__PURE__ */ Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM);
var Init = function (x) {
    return x;
};
var MkClosure = function (x) {
    return x;
};
var VariableNotFound = /* #__PURE__ */ (function () {
    function VariableNotFound(value0) {
        this.value0 = value0;
    };
    VariableNotFound.create = function (value0) {
        return new VariableNotFound(value0);
    };
    return VariableNotFound;
})();
var StepBack = /* #__PURE__ */ (function () {
    function StepBack() {

    };
    StepBack.value = new StepBack();
    return StepBack;
})();
var StepForward = /* #__PURE__ */ (function () {
    function StepForward() {

    };
    StepForward.value = new StepForward();
    return StepForward;
})();
var Done = /* #__PURE__ */ (function () {
    function Done() {

    };
    Done.value = new Done();
    return Done;
})();
var KontArg = /* #__PURE__ */ (function () {
    function KontArg(value0) {
        this.value0 = value0;
    };
    KontArg.create = function (value0) {
        return new KontArg(value0);
    };
    return KontArg;
})();
var KontApp = /* #__PURE__ */ (function () {
    function KontApp(value0) {
        this.value0 = value0;
    };
    KontApp.create = function (value0) {
        return new KontApp(value0);
    };
    return KontApp;
})();
var Uninitialized = /* #__PURE__ */ (function () {
    function Uninitialized() {

    };
    Uninitialized.value = new Uninitialized();
    return Uninitialized;
})();
var Working = /* #__PURE__ */ (function () {
    function Working(value0) {
        this.value0 = value0;
    };
    Working.create = function (value0) {
        return new Working(value0);
    };
    return Working;
})();
var Final = /* #__PURE__ */ (function () {
    function Final(value0) {
        this.value0 = value0;
    };
    Final.create = function (value0) {
        return new Final(value0);
    };
    return Final;
})();
var Review = /* #__PURE__ */ (function () {
    function Review(value0) {
        this.value0 = value0;
    };
    Review.create = function (value0) {
        return new Review(value0);
    };
    return Review;
})();
var genericClosure_ = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericClosure_);
var showClosure = {
    show: function (c) {
        return genericShow(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsCons(Data_Show.showArray(showRecord(showRecordFieldsCons1(showRecordFieldsConsNil(showClosure))(Data_Show.showString)))))))(MkClosureIsSymbol))(c);
    }
};
var genericAction_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return StepBack.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return StepForward.value;
        };
        throw new Error("Failed pattern match at CEK (line 371, column 1 - line 371, column 33): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof StepBack) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof StepForward) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at CEK (line 371, column 1 - line 371, column 33): " + [ x.constructor.name ]);
    }
};
var showAction = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericAction_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "StepBack";
        }
    }))(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "StepForward";
        }
    })))
};
var eqClosure = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Eq.eqArray(eqRec(Data_Eq.eqRowCons(eqRowCons1(eqClosure))()(nameIsSymbol)(Data_Eq.eqString))))(x.environment)(y.environment) && eq(x.target)(y.target);
        };
    }
};
var eqArray = /* #__PURE__ */ Data_Eq.eqArray(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons1(eqClosure))()(nameIsSymbol)(Data_Eq.eqString)));
var eq2 = /* #__PURE__ */ Data_Eq.eq(eqArray);
var eqKontinuation = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Done && y instanceof Done) {
                return true;
            };
            if (x instanceof KontArg && y instanceof KontArg) {
                return eq(x.value0.argument)(y.value0.argument) && eq2(x.value0.environment)(y.value0.environment) && Data_Eq.eq(eqKontinuation)(x.value0.next)(y.value0.next);
            };
            if (x instanceof KontApp && y instanceof KontApp) {
                return x.value0.abstraction.binder === y.value0.abstraction.binder && eq(x.value0.abstraction.body)(y.value0.abstraction.body) && eq2(x.value0.environment)(y.value0.environment) && Data_Eq.eq(eqKontinuation)(x.value0.next)(y.value0.next);
            };
            return false;
        };
    }
};
var eqMachineError = {
    eq: function (x) {
        return function (y) {
            return eq2(x.value0.environment)(y.value0.environment) && x.value0.name === y.value0.name;
        };
    }
};
var eq3 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Either.eqEither(eqMachineError)(/* #__PURE__ */ Data_Either.eqEither(Expr.eqExpr)(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons({
    reflectSymbol: function () {
        return "kontinuation";
    }
})(eqKontinuation))()(environmentIsSymbol)(eqArray))()({
    reflectSymbol: function () {
        return "control";
    }
})(Expr.eqExpr)))));
var eqAction = {
    eq: function (x) {
        return function (y) {
            if (x instanceof StepBack && y instanceof StepBack) {
                return true;
            };
            if (x instanceof StepForward && y instanceof StepForward) {
                return true;
            };
            return false;
        };
    }
};
var pred = function (s) {
    return max(0)(s - 1 | 0);
};
var lzInit = function (lz) {
    if (lz.previousReverse instanceof Data_List_Types.Nil) {
        return lz;
    };
    if (lz.previousReverse instanceof Data_List_Types.Cons) {
        return {
            previousReverse: lz.previousReverse.value1,
            current: lz.previousReverse.value0,
            future: new Data_List_Types.Cons(lz.current, lz.future)
        };
    };
    throw new Error("Failed pattern match at CEK (line 349, column 13 - line 352, column 68): " + [ lz.previousReverse.constructor.name ]);
};
var initialMachineState = function (control) {
    return {
        control: control,
        environment: [  ],
        kontinuation: Done.value
    };
};
var genKont = function (dictMonadRec) {
    var genAlphaString = Data_String_Gen.genAlphaString(dictMonadRec);
    return function (dictMonadGen) {
        var resize = Control_Monad_Gen_Class.resize(dictMonadGen);
        var Monad0 = dictMonadGen.Monad0();
        var pure1 = Control_Applicative.pure(Monad0.Applicative0());
        var Apply0 = (Monad0.Bind1()).Apply0();
        var apply = Control_Apply.apply(Apply0);
        var map1 = Data_Functor.map(Apply0.Functor0());
        var genAlphaString1 = genAlphaString(dictMonadGen);
        var oneOf = Control_Monad_Gen.oneOf(dictMonadGen)(Data_Array_NonEmpty_Internal.foldable1NonEmptyArray);
        var sized = Control_Monad_Gen_Class.sized(dictMonadGen);
        return function (expr) {
            return function (env) {
                return function (k) {
                    var smaller = resize((function () {
                        var $302 = max(0);
                        return function ($303) {
                            return $302((function (v) {
                                return v - 1 | 0;
                            })($303));
                        };
                    })())(k);
                    var small = pure1(Done.value);
                    var arg = apply(apply(map1(function (v) {
                        return function (v1) {
                            return function (v2) {
                                return {
                                    argument: v,
                                    environment: v1,
                                    next: v2
                                };
                            };
                        };
                    })(expr))(env))(smaller);
                    var app = apply(apply(map1(function (v) {
                        return function (v1) {
                            return function (v2) {
                                return {
                                    abstraction: v,
                                    environment: v1,
                                    next: v2
                                };
                            };
                        };
                    })(apply(map1(function (v) {
                        return function (v1) {
                            return {
                                binder: v,
                                body: v1
                            };
                        };
                    })(genAlphaString1))(expr)))(env))(smaller);
                    var large = oneOf(Data_Array_NonEmpty["cons$prime"](small)([ map1(KontArg.create)(arg), map1(KontApp.create)(app) ]));
                    return sized(function (size) {
                        var $237 = size <= 1;
                        if ($237) {
                            return small;
                        };
                        return large;
                    });
                };
            };
        };
    };
};
var genE = function (dictApplicative) {
    var Apply0 = dictApplicative.Apply0();
    var apply = Control_Apply.apply(Apply0);
    var map1 = Data_Functor.map(Apply0.Functor0());
    return function (dictMonadGen) {
        return function (dictMonadRec) {
            var genAlphaString = Data_String_Gen.genAlphaString(dictMonadRec)(dictMonadGen);
            var unfoldable = Control_Monad_Gen.unfoldable(dictMonadRec)(dictMonadGen)(Data_Unfoldable.unfoldableArray);
            return function (genClos) {
                var genEntry = apply(map1(function (v) {
                    return function (v1) {
                        return {
                            name: v,
                            value: v1
                        };
                    };
                })(genAlphaString))(genClos);
                return unfoldable(genEntry);
            };
        };
    };
};
var genC = function (dictApplicative) {
    var Apply0 = dictApplicative.Apply0();
    var apply = Control_Apply.apply(Apply0);
    var map1 = Data_Functor.map(Apply0.Functor0());
    return function (dictMonadRec) {
        return function (dictMonadGen) {
            return function (genExpr) {
                return function (genEnv) {
                    return apply(map1(function (v) {
                        return function (v1) {
                            return {
                                target: v,
                                environment: v1
                            };
                        };
                    })(genExpr))(genEnv);
                };
            };
        };
    };
};
var genClosure = function (dictApplicative) {
    var genC1 = genC(dictApplicative);
    var genE1 = genE(dictApplicative);
    return function (dictMonadRec) {
        var genC2 = genC1(dictMonadRec);
        var generator = Expr.generator(dictMonadRec);
        return function (dictMonadGen) {
            var genC3 = genC2(dictMonadGen);
            var resize = Control_Monad_Gen_Class.resize(dictMonadGen);
            var generator1 = generator(dictMonadGen);
            var genE2 = genE1(dictMonadGen)(dictMonadRec);
            return function (dictLazy) {
                var half = function (n) {
                    return Data_Int.quot(n)(2);
                };
                return Control_Lazy.fix(dictLazy)(function (gc) {
                    return genC3(resize(half)(generator1))(genE2(resize(half)(gc)));
                });
            };
        };
    };
};
var genEnvironment = function (dictApplicative) {
    var genE1 = genE(dictApplicative);
    var genC1 = genC(dictApplicative);
    return function (dictMonadRec) {
        var genC2 = genC1(dictMonadRec);
        var generator = Expr.generator(dictMonadRec);
        return function (dictMonadGen) {
            var genE2 = genE1(dictMonadGen)(dictMonadRec);
            var genC3 = genC2(dictMonadGen);
            var generator1 = generator(dictMonadGen);
            var resize = Control_Monad_Gen_Class.resize(dictMonadGen);
            return function (dictLazy) {
                return Control_Lazy.fix(dictLazy)(function (ge) {
                    return genE2(genC3(generator1)(resize(function ($304) {
                        return Data_Int.trunc(Data_Number.sqrt(Data_Int.toNumber(pred($304))));
                    })(ge)));
                });
            };
        };
    };
};
var genKontinuation = function (dictMonadRec) {
    var genKont1 = genKont(dictMonadRec);
    var generator = Expr.generator(dictMonadRec);
    return function (dictMonadGen) {
        var genKont2 = genKont1(dictMonadGen);
        var generator1 = generator(dictMonadGen);
        var genEnvironment1 = genEnvironment((dictMonadGen.Monad0()).Applicative0())(dictMonadRec)(dictMonadGen);
        return function (dictLazy) {
            return function (dictLazy1) {
                var genEnvironment2 = genEnvironment1(dictLazy1);
                return function (dictLazy2) {
                    return Control_Lazy.fix(dictLazy2)(genKont2(generator1)(genEnvironment2));
                };
            };
        };
    };
};
var displayEnvironment = function (env) {
    var displayClosure = function (v) {
        return [ Expr.render(v.target), displayEnvironment(v.environment) ];
    };
    var displayEntry = function (ent) {
        return Halogen_HTML_Elements.tr([ Halogen_HTML_Properties.class_("environment-entry") ])([ Halogen_HTML_Elements.td_([ Halogen_HTML_Core.text(ent.name) ]), Halogen_HTML_Elements.td([ Halogen_HTML_Properties.class_("environment-closure") ])(displayClosure(ent.value)) ]);
    };
    var $243 = Data_Array["null"](env);
    if ($243) {
        return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("environment-empty") ])([ Halogen_HTML_Core.text("<empty>") ]);
    };
    return Halogen_HTML_Elements.table([ Halogen_HTML_Properties.class_("environment-nonEmpty") ])([ Halogen_HTML_Elements.thead_([ Halogen_HTML_Elements.tr_([ Halogen_HTML_Elements.th_([ Halogen_HTML_Core.text("Name") ]), Halogen_HTML_Elements.th_([ Halogen_HTML_Core.text("Value") ]) ]) ]), Halogen_HTML_Elements.tbody_(map(displayEntry)(env)) ]);
};
var displayKontinuation = function (kont) {
    var andThen = Halogen_HTML_Core.text(", and then...");
    var kontArray = function (v) {
        if (v instanceof Done) {
            return [ Halogen_HTML_Elements.li_([ Halogen_HTML_Core.text("evaluation is complete.") ]) ];
        };
        if (v instanceof KontArg) {
            return Data_Array.cons(Halogen_HTML_Elements.li_([ Halogen_HTML_Core.text("evaluate the argument"), Expr.render(v.value0.argument), Halogen_HTML_Core.text("in the environment"), displayEnvironment(v.value0.environment), Halogen_HTML_Core.text("and apply the current result to it"), andThen ]))(kontArray(v.value0.next));
        };
        if (v instanceof KontApp) {
            return Data_Array.cons(Halogen_HTML_Elements.li_([ Halogen_HTML_Core.text("evaluate the function body"), Expr.render(v.value0.abstraction.body), Halogen_HTML_Core.text("in the envionrment"), displayEnvironment(v.value0.environment), Halogen_HTML_Core.text("extended by binding the current result to " + show(v.value0.abstraction.binder)), andThen ]))(kontArray(v.value0.next));
        };
        throw new Error("Failed pattern match at CEK (line 269, column 3 - line 269, column 62): " + [ v.constructor.name ]);
    };
    return Halogen_HTML_Elements.ol([ Halogen_HTML_Properties.class_("kontinuation") ])(kontArray(kont));
};
var displayMachineState = function (st) {
    return Halogen_HTML_Elements.table([ Halogen_HTML_Properties.class_("machine-state") ])([ Halogen_HTML_Elements.thead_([ Halogen_HTML_Elements.tr_([ Halogen_HTML_Elements.th_([ Halogen_HTML_Core.text("Control") ]), Halogen_HTML_Elements.th_([ Halogen_HTML_Core.text("Environment") ]), Halogen_HTML_Elements.th_([ Halogen_HTML_Core.text("Kontinuation") ]) ]) ]), Halogen_HTML_Elements.tbody_([ Halogen_HTML_Elements.tr_([ Halogen_HTML_Elements.td_([ Expr.render(st.control) ]), Halogen_HTML_Elements.td_([ displayEnvironment(st.environment) ]), Halogen_HTML_Elements.td_([ displayKontinuation(st.kontinuation) ]) ]) ]) ]);
};
var cekStep = function (dictMonadThrow) {
    var throwError = Control_Monad_Error_Class.throwError(dictMonadThrow);
    var pure1 = Control_Applicative.pure((dictMonadThrow.Monad0()).Applicative0());
    return function (v) {
        return function (v1) {
            return function (v2) {
                if (v instanceof Expr.Variable) {
                    var onEntry = function (ent) {
                        var $250 = v.value0 === ent.name;
                        if ($250) {
                            return new Data_Maybe.Just(ent.value);
                        };
                        return Data_Maybe.Nothing.value;
                    };
                    var onClosure = function (v3) {
                        return {
                            control: v3.target,
                            environment: v3.environment,
                            kontinuation: v2
                        };
                    };
                    return Data_Maybe.maybe(throwError(new VariableNotFound({
                        name: v.value0,
                        environment: v1
                    })))(function ($305) {
                        return pure1(Data_Either.Right.create(onClosure($305)));
                    })(Data_Array.findMap(onEntry)(v1));
                };
                if (v instanceof Expr.Application) {
                    return pure1(new Data_Either.Right({
                        control: v["value0"]["function"],
                        environment: v1,
                        kontinuation: new KontArg({
                            argument: v.value0.argument,
                            environment: v1,
                            next: v2
                        })
                    }));
                };
                if (v2 instanceof Done) {
                    return pure1(new Data_Either.Left(v));
                };
                if (v instanceof Expr.Abstraction && v2 instanceof KontArg) {
                    return pure1(new Data_Either.Right({
                        control: v2.value0.argument,
                        environment: v2.value0.environment,
                        kontinuation: new KontApp({
                            abstraction: {
                                binder: v.value0.binder,
                                body: v.value0.body
                            },
                            environment: v1,
                            next: v2.value0.next
                        })
                    }));
                };
                if (v2 instanceof KontApp) {
                    return pure1(new Data_Either.Right({
                        control: v2.value0.abstraction.body,
                        environment: Data_Array.cons({
                            name: v2.value0.abstraction.binder,
                            value: {
                                target: v,
                                environment: v1
                            }
                        })(v2.value0.environment),
                        kontinuation: v2.value0.next
                    }));
                };
                throw new Error("Failed pattern match at CEK (line 196, column 1 - line 202, column 31): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
            };
        };
    };
};
var cekStep1 = /* #__PURE__ */ cekStep(Control_Monad_Error_Class.monadThrowEither);
var checkStepBoundVariable = function (x) {
    return function (v) {
        return function (et) {
            return function (k) {
                var ost = {
                    control: v.target,
                    environment: v.environment,
                    kontinuation: k
                };
                var e = Data_Array.cons({
                    name: x,
                    value: v
                })(et);
                return eq3(new Data_Either.Right(new Data_Either.Right(ost)))(cekStep1(new Expr.Variable(x))(e)(k));
            };
        };
    };
};
var component = /* #__PURE__ */ (function () {
    var stepForward = function (st) {
        if (st instanceof Uninitialized) {
            return st;
        };
        if (st instanceof Working) {
            if (st.value0.future instanceof Data_List_Types.Nil) {
                var v = cekStep1(st.value0.current.control)(st.value0.current.environment)(st.value0.current.kontinuation);
                if (v instanceof Data_Either.Left) {
                    return new Final({
                        initReverse: st.value0.previousReverse,
                        last: st.value0.current,
                        result: new Data_Either.Left(v.value0)
                    });
                };
                if (v instanceof Data_Either.Right) {
                    if (v.value0 instanceof Data_Either.Left) {
                        return new Final({
                            initReverse: st.value0.previousReverse,
                            last: st.value0.current,
                            result: new Data_Either.Right(v.value0.value0)
                        });
                    };
                    if (v.value0 instanceof Data_Either.Right) {
                        return new Working({
                            previousReverse: new Data_List_Types.Cons(st.value0.current, st.value0.previousReverse),
                            current: v.value0.value0,
                            future: Data_List_Types.Nil.value
                        });
                    };
                    throw new Error("Failed pattern match at CEK (line 467, column 27 - line 476, column 20): " + [ v.value0.constructor.name ]);
                };
                throw new Error("Failed pattern match at CEK (line 464, column 11 - line 476, column 20): " + [ v.constructor.name ]);
            };
            if (st.value0.future instanceof Data_List_Types.Cons) {
                return new Working({
                    previousReverse: new Data_List_Types.Cons(st.value0.current, st.value0.previousReverse),
                    current: st.value0.future.value0,
                    future: st.value0.future.value1
                });
            };
            throw new Error("Failed pattern match at CEK (line 461, column 19 - line 482, column 12): " + [ st.value0.future.constructor.name ]);
        };
        if (st instanceof Final) {
            return st;
        };
        if (st instanceof Review) {
            if (st.value0.process.future instanceof Data_List_Types.Nil) {
                return new Final({
                    initReverse: st.value0.process.previousReverse,
                    last: st.value0.process.current,
                    result: st.value0.result
                });
            };
            if (st.value0.process.future instanceof Data_List_Types.Cons) {
                return new Review({
                    result: st.value0.result,
                    process: {
                        previousReverse: new Data_List_Types.Cons(st.value0.process.current, st.value0.process.previousReverse),
                        current: st.value0.process.future.value0,
                        future: st.value0.process.future.value1
                    }
                });
            };
            throw new Error("Failed pattern match at CEK (line 484, column 38 - line 499, column 16): " + [ st.value0.process.future.constructor.name ]);
        };
        throw new Error("Failed pattern match at CEK (line 459, column 20 - line 499, column 16): " + [ st.constructor.name ]);
    };
    var stepBack = function (st) {
        if (st instanceof Uninitialized) {
            return st;
        };
        if (st instanceof Working) {
            return new Working(lzInit(st.value0));
        };
        if (st instanceof Final) {
            return new Review({
                process: {
                    previousReverse: st.value0.initReverse,
                    current: st.value0.last,
                    future: Data_List_Types.Nil.value
                },
                result: st.value0.result
            });
        };
        if (st instanceof Review) {
            return new Review({
                result: st.value0.result,
                process: lzInit(st.value0.process)
            });
        };
        throw new Error("Failed pattern match at CEK (line 445, column 17 - line 457, column 61): " + [ st.constructor.name ]);
    };
    var render = (function () {
        var controls = Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("cek-component-controls") ])([ Halogen_HTML_Elements.button([ Halogen_HTML_Properties.disabled(true) ])([ Halogen_HTML_Core.text("|<") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Properties.disabled(true) ])([ Halogen_HTML_Core.text("<<") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(Data_Function["const"](StepBack.value)) ])([ Halogen_HTML_Core.text("<") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(Data_Function["const"](StepForward.value)) ])([ Halogen_HTML_Core.text(">") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Properties.disabled(true) ])([ Halogen_HTML_Core.text(">>") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Properties.disabled(true) ])([ Halogen_HTML_Core.text(">>>") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Properties.disabled(true) ])([ Halogen_HTML_Core.text(">|") ]) ]);
        return function (v) {
            if (v instanceof Uninitialized) {
                return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("cek-component-uninitialized") ])([ Halogen_HTML_Core.text("No valid expression, yet.") ]);
            };
            if (v instanceof Working) {
                return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("cek-component-working") ])([ controls, displayMachineState(v.value0.current) ]);
            };
            if (v instanceof Final) {
                var displayResult = function (v1) {
                    if (v1 instanceof Data_Either.Left) {
                        return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("cek-machine-error-variable-not-found") ])([ Halogen_HTML_Core.text("The variable "), Halogen_HTML_Core.text(show(v1.value0.value0.name)), Halogen_HTML_Core.text(" was not found in the environemnt:"), displayEnvironment(v1.value0.value0.environment) ]);
                    };
                    if (v1 instanceof Data_Either.Right) {
                        return Expr.render(v1.value0);
                    };
                    throw new Error("Failed pattern match at CEK (line 404, column 23 - line 414, column 41): " + [ v1.constructor.name ]);
                };
                return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("cek-component-final") ])([ controls, displayResult(v.value0.result) ]);
            };
            if (v instanceof Review) {
                return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("cek-component-review") ])([ controls, displayMachineState(v.value0.process.current) ]);
            };
            throw new Error("Failed pattern match at CEK (line 390, column 12 - line 418, column 63): " + [ v.constructor.name ]);
        };
    })();
    var handleQuery = function (v) {
        return discard(put(new Working({
            previousReverse: Data_List_Types.Nil.value,
            current: initialMachineState(v),
            future: Data_List_Types.Nil.value
        })))(function () {
            return pure(Data_Maybe.Nothing.value);
        });
    };
    var handleAction = function (act) {
        return discard((function () {
            if (act instanceof StepBack) {
                return modify_(stepBack);
            };
            if (act instanceof StepForward) {
                return modify_(stepForward);
            };
            throw new Error("Failed pattern match at CEK (line 502, column 5 - line 504, column 41): " + [ act.constructor.name ]);
        })())(function () {
            return pure(Data_Unit.unit);
        });
    };
    return Halogen_Component.mkComponent({
        initialState: Data_Function["const"](Uninitialized.value),
        render: render,
        "eval": Halogen_Component.mkEval({
            initialize: Data_Maybe.Nothing.value,
            receive: Data_Function["const"](Data_Maybe.Nothing.value),
            handleAction: handleAction,
            handleQuery: handleQuery,
            finalize: Data_Maybe.Nothing.value
        })
    });
})();
export {
    genEnvironment,
    MkClosure,
    genClosure,
    Done,
    KontArg,
    KontApp,
    genKontinuation,
    checkStepBoundVariable,
    Init,
    component,
    eqClosure,
    genericClosure_,
    showClosure,
    eqKontinuation
};
//# sourceMappingURL=index.js.map
